// extracted by mini-css-extract-plugin
export default {"scrollPagination":"_zqS34A2GOLD84xnbB7i","common_bganimation":"bP8f14NGUxiDvTtV09mj"};